export const SOBRE_REQUEST = "SOBRE_REQUEST";
export const SOBRE_SUCCESS = "SOBRE_SUCCESS";
export const SOBRE_FAIL = "SOBRE_FAIL";
